// extracted by mini-css-extract-plugin
export default {"card-uninterested-tooltip":"index_card-uninterested-tooltip__MANh4","card-uninterested":"index_card-uninterested__O6znh"};